import styled from 'styled-components';
import { primaryColor } from '../../../pages/dash/styles'; 

export const StatCardContainer = styled.div`
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 20px;
  height: 156px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center; /* centraliza conteúdo */
  justify-content: space-between;
`;

export const StatHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between; /* título à esquerda, ícone à direita */
  align-items: center;
`;

export const StatTitle = styled.div`
  font-size: 16px;
  color: #566474;
  font-weight: 500;
`;

export const StatValue = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: #333333;
  text-align: center;
`;

export const StatLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${props => {
    switch(props.type) {
      case 'eventos': return primaryColor;
      case 'oportunidades': return '#66BB6A';
      case 'cursos': return '#AB47BC';
      case 'usuarios': return '#EC407A';
      default: return '#566474';
    }
  }};
  text-align: center;
`;

export const StatIconContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  
  background-color: ${props => {
    switch(props.type) {
      case 'eventos': return '#DBEAFE';
      case 'oportunidades': return '#DCFCE7';
      case 'cursos': return '#F3E8FF';
      case 'usuarios': return '#FCE7F3';
      default: return '#EEE';
    }
  }};
  
  color: ${props => {
    switch(props.type) {
      case 'eventos': return primaryColor;
      case 'oportunidades': return '#66BB6A';
      case 'cursos': return '#AB47BC';
      case 'usuarios': return '#EC407A';
      default: return '#333';
    }
  }};
`;
